<template>
    <span>
      {{ $t('soldBy') }} :
        <v-select v-if="userInfo.id == 6" @input="changeBuyer" v-model="selectedUser" :options="users"
                  :clearable="false" class="input-select vs-select&#45;&#45;input"
                  style="min-width: 25%;display: inline-block"/>
    </span>
</template>

<script>
import vSelect from "vue-select";

export default {
    components: {
        'v-select': vSelect,
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        users: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            userInfo: window.userInfo,
            selectedUser: {},
        }
    },
    methods: {
        checkComment() {
            if (this.comment !== this.item.comment) {
                const thisIns = this;
                this.$vs.loading();

                axios.post(apiUrl + '/order/' + this.item.intId + '/change/comment?token=' + token, {comment: this.comment})
                    .then(function (response) {

                        let data = response.data;
                        if (data.code === 200) {
                            thisIns.item.comment = thisIns.comment;
                        } else {
                            if (data.code === 401) {
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text: data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                        thisIns.$vs.loading.close();
                    });
            }
        },
        changeBuyer() {

            const thisIns = this;
            this.$vs.loading();

            axios.post(apiUrl + '/order/' + this.item.intId + '/change/buyer?token=' + token, {buyerId: this.selectedUser.id})
                .then(function (response) {

                    let data = response.data;
                    if (data.code === 200) {

                    } else {
                        if (data.code === 401) {
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                    thisIns.$vs.loading.close();
                });
        }
    },
    created() {
        this.selectedUser = {id: this.item.buyer.id, label: this.item.buyer.name};
    }
}
</script>

<style lang="scss" scoped>

</style>
